import { Image } from 'antd';
import styled from 'styled-components';

export const ClientImage = styled(Image)`
  cursor: pointer;
  filter: grayscale(100%);
`;
